"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const js_cookie_1 = __importDefault(require("js-cookie"));
const GtmDataLayer_1 = __importDefault(require("@react/common/GtmDataLayer/GtmDataLayer"));
const Pageshow_1 = __importDefault(require("@web/common/Pageshow"));
class AbandonedInquiryCarModal {
    static isAbandonedInquiryHidden() {
        return js_cookie_1.default.get('abandonedInquiryIdentifier') === undefined;
    }
    static isScrolledToHeaderBottomEdge() {
        if (this.header) {
            return window.scrollY > this.header.offsetHeight;
        }
        return false;
    }
    static isCarDetailStickyPanelDisplayed() {
        if (this.carOfferDetailStickyPanel) {
            return this.carOfferDetailStickyPanel.classList.contains('fixed');
        }
        return false;
    }
    static handleScroll() {
        const self = this;
        window.addEventListener('scroll', () => {
            if (self.abandonedInquiryCarModal === null) {
                return;
            }
            if (self.isScrolledToHeaderBottomEdge()) {
                self.abandonedInquiryCarModal.classList.add('fixed');
                const translateYValue = self.isCarDetailStickyPanelDisplayed() ? '80px' : '0px';
                self.abandonedInquiryCarModal.style.transform = `translateY(${translateYValue})`;
            }
            else {
                self.abandonedInquiryCarModal.classList.remove('fixed');
            }
        });
    }
    static handleClick() {
        if (this.abandonedInquiryCarModal === null) {
            return;
        }
        const closeModal = this.abandonedInquiryCarModal.querySelector('.close-modal');
        const self = this;
        if (closeModal) {
            closeModal.addEventListener('click', () => {
                if (self.abandonedInquiryCarModal) {
                    self.abandonedInquiryCarModal.remove();
                    const { cookieName } = self.abandonedInquiryCarModal.dataset;
                    if (cookieName) {
                        js_cookie_1.default.remove(cookieName);
                    }
                }
            });
        }
    }
    static handleLoad() {
        window.addEventListener('load', () => {
            (0, GtmDataLayer_1.default)({
                event: 'abandoned_inquiry_modal_displayed',
            });
        });
    }
    static refresh() {
        if (this.abandonedInquiryCarModal && this.isAbandonedInquiryHidden()) {
            this.abandonedInquiryCarModal.remove();
        }
    }
    static init() {
        if (this.abandonedInquiryCarModal === null) {
            return;
        }
        this.handleScroll();
        this.handleClick();
        this.handleLoad();
    }
}
AbandonedInquiryCarModal.abandonedInquiryCarModal = document.querySelector('.abandoned-inquiry-car-modal');
AbandonedInquiryCarModal.carOfferDetailStickyPanel = document.querySelector('#sticky-panel-container');
AbandonedInquiryCarModal.header = document.querySelector('header');
(() => {
    AbandonedInquiryCarModal.init();
    (0, Pageshow_1.default)(() => {
        AbandonedInquiryCarModal.refresh();
    });
})();
